import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useAuth } from '../../components/auth/AuthContext';
import { useOFEFetch, ofePost } from './useOFE';

export default function OFEJEReview() {
  const { id: project } = useParams();
  const { user } = useAuth();
  const [processing, setProcessing] = useState({});
  const [errors, setErrors] = useState({});
  const { data: proposals, loading, reload } = useOFEFetch('/ofe/financials/je?status=proposed', user);

  const decide = async (jeId, decision) => {
    setProcessing(p => ({ ...p, [jeId]: true }));
    setErrors(e => ({ ...e, [jeId]: null }));
    try {
      await ofePost(`/ofe/financials/je/${jeId}/review`, { decision }, user);
      reload();
    } catch (e) {
      setErrors(prev => ({ ...prev, [jeId]: e.message }));
    } finally {
      setProcessing(p => ({ ...p, [jeId]: false }));
    }
  };

  return (
    <div className="p-6 space-y-4">
      <div className="flex items-center gap-4">
        {project && project !== 'all' && (
          <Link to={`/ofe/projects/${project}/financials`} className="text-gray-400 hover:text-white text-sm">← Financials</Link>
        )}
        <h1 className="text-xl font-bold text-white">JE Review Queue</h1>
        <span className="text-gray-400 text-sm">{proposals?.length || 0} proposals pending Finance review</span>
      </div>

      <div className="bg-yellow-900/10 border border-yellow-800/40 rounded-lg p-4 text-yellow-300 text-sm">
        <strong>Finance:</strong> Review each AI-proposed journal entry below. Approving posts it to Oracle. Rejecting sends it back for revision.
      </div>

      {loading && <div className="text-gray-400">Loading proposals...</div>}

      <div className="space-y-4">
        {(proposals || []).map(je => (
          <div key={je.id} className="bg-gray-800 border border-gray-700 rounded-lg p-4">
            <div className="flex items-center justify-between mb-3">
              <div>
                <span className="text-white font-semibold">JE Proposal</span>
                <span className="text-gray-400 font-mono text-xs ml-3">{je.id?.slice(0, 8)}</span>
                <span className="ml-2 text-xs px-2 py-0.5 rounded-full bg-yellow-900/40 text-yellow-400">{je.trigger_type}</span>
              </div>
              <span className="text-gray-400 text-xs">{je.created_at?.slice(0, 16)}</span>
            </div>

            {je.policy_id && (
              <div className="text-xs text-gray-500 mb-2">Policy: <span className="font-mono text-gray-400">{je.policy_id}</span></div>
            )}
            {je.notes && <p className="text-gray-300 text-sm mb-3">{je.notes}</p>}

            {errors[je.id] && <div className="text-red-400 text-sm mb-2">{errors[je.id]}</div>}

            <div className="flex gap-2">
              <button onClick={() => decide(je.id, 'approved')} disabled={processing[je.id]}
                className="bg-green-700 hover:bg-green-600 disabled:opacity-50 text-white px-4 py-1.5 rounded text-sm font-semibold">
                {processing[je.id] ? 'Processing...' : '✓ Approve'}
              </button>
              <button onClick={() => decide(je.id, 'rejected')} disabled={processing[je.id]}
                className="bg-red-800 hover:bg-red-700 disabled:opacity-50 text-white px-4 py-1.5 rounded text-sm">
                ✗ Reject
              </button>
            </div>
          </div>
        ))}
        {!proposals?.length && !loading && (
          <div className="text-center py-12 text-gray-500">No journal entry proposals pending review</div>
        )}
      </div>
    </div>
  );
}
